import { ScopeButton } from '@monorepo/shared-lib';
import { FormInput } from 'components/Custom/inputs';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { turnDrawerOff } from 'store/app/actions';
import { createExcelTaxRateRequest } from 'store/tax-rates/actions';
import { ExcelTaxRateRequest } from 'store/tax-rates/api';
import styled from 'styled-components';

const Wrapper = styled.div`
  background: var(--color-surface-raised, #ffffff);
  font-family: Inter, sans-serif;
  padding: 16px 20px 24px;

  .field-label {
    font-family: Inter, sans-serif;
    font-weight: 600;
    font-size: 14px;
    color: var(--color-text-base, #2e2e2e);
    margin-bottom: 6px;
    display: block;
  }

  .field-group {
    margin-bottom: 16px;
  }
`;

interface AddCustomTaxRateProps {
  connectionId: string;
}

export const AddCustomTaxRate: React.FC<AddCustomTaxRateProps> = ({
  connectionId,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [taxName, setTaxName] = React.useState('');
  const [taxRate, setTaxRate] = React.useState<string>('');

  const parsedRate = Number(taxRate);
  const isValidRate =
    !Number.isNaN(parsedRate) && parsedRate >= 0 && parsedRate <= 100;

  const canSave = !!connectionId && taxName.trim().length > 0 && isValidRate;

  const handleSave = () => {
    if (!canSave) return;

    const payload: ExcelTaxRateRequest = {
      taxName: taxName.trim(),
      taxRate: parsedRate,
    };

    dispatch(createExcelTaxRateRequest(connectionId, payload));
    dispatch(turnDrawerOff());
  };

  return (
    <Wrapper>
      <div className="field-group">
        <label htmlFor="custom-tax-name" className="field-label">
          {t('organisation.tax-name')}
        </label>
        <FormInput
          id="custom-tax-name"
          width="100%"
          placeholder={t('organisation.enter-tax-name')}
          value={taxName}
          onChange={(e) => setTaxName(e.target.value)}
        />
      </div>

      <div className="field-group">
        <label htmlFor="custom-tax-rate" className="field-label">
          {t('organisation.tax-rate-percent')}
        </label>
        <FormInput
          id="custom-tax-rate"
          width="100%"
          placeholder={t('organisation.enter-tax-rate-example-20')}
          value={taxRate}
          onChange={(e) => setTaxRate(e.target.value)}
        />
      </div>

      <ScopeButton
        type="primary"
        width="100%"
        height="40px"
        fontSize="14px"
        onClick={handleSave}
        disabled={!canSave}
      >
        {t('organisation.add-tax-rate')}
      </ScopeButton>
    </Wrapper>
  );
};
